import React from 'react';

import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import MainTitle from '../../components/page/main-title/MainTitle';
import Modal from '../../components/modal.v2/Modal';
import Detail from './Detail';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import ItemTreino from './ItemTreino';
import Button from '../../components/buttons/Button';

const URL_LOAD = WS.meuTreino.load;
const URL_DETAIL = WS.meuTreino.detalhe;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      lista: [],
      strings: STRINGS[window.LANGUAGE]
    };

    this.callDetalhe = this.callDetalhe.bind(this);
    this.sendByMail = this.sendByMail.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);
    document.body.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL_LOAD,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            ...data.data,
            loaded: true
          });
        }else{
          if(data.expired){
            _self.props.history.push('/');
          }else{
            msg = {
              title: atencao,
              text: data.msg
            };
            Dialog.create(msg);
          }

        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  sendByMail(e){
    const _self = this;
    const {atencao, erroTreino, sucessTreino} = this.state.strings;

    Requisitions({
      url: WS.meuTreino.imprimir,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          msg = {
            title: atencao,
            text: 'Treino enviado com sucesso'
          };
          Dialog.create(msg);
        }else{
          msg = {
            title: atencao,
            text: 'Ocorreu um erro ao enviar o treino'
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
    e.preventDefault();
  }

  getLista() {console.log(this.state.lista);
    let lista = this.state.lista.map((value, i) =>
      <ItemTreino
        key={i}
        data={value}
        onClick={(e)=>this.callDetalhe(e,value.id)}
      />
    );

    return lista;
  }

  callDetalhe(e,id) {
    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL_DETAIL,
      data: { id },
      sucess:function(data){
        var msg;

        if(data.status){
          Modal.create({
            content: <Detail data={data.data} />
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });

    e.preventDefault();
  }

  getObs(){

    return(<div>
      <br />
      <strong>Observações</strong>
      <br />
      {this.state.observacoes }
    </div>);
  }

  render() {
    const lista = this.state.lista.length ? this.getLista() : null;
    const observacoes= this.state.observacoes ? this.getObs() : null;
    const strings = this.state.strings;


    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <div>
                <MainTitle title="Meu treino"></MainTitle>
                  <Button
                    text={strings.txtSendByMail}
                    type='submit'
                    onClick={this.sendByMail}
                    classes="button-blue simple-button bt-send-mail"
                  />
              </div>
              <div>{lista}</div>
              {observacoes}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/treino/Page.js